var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 8.49992C5.88677 8.49992 4.16677 6.77992 4.16677 4.66659C4.16677 2.55325 5.88677 0.833252 8.0001 0.833252C10.1134 0.833252 11.8334 2.55325 11.8334 4.66659C11.8334 6.77992 10.1134 8.49992 8.0001 8.49992ZM8.0001 1.83325C6.4401 1.83325 5.16677 3.10659 5.16677 4.66659C5.16677 6.22659 6.4401 7.49992 8.0001 7.49992C9.5601 7.49992 10.8334 6.22659 10.8334 4.66659C10.8334 3.10659 9.5601 1.83325 8.0001 1.83325ZM13.7268 15.1666C13.4534 15.1666 13.2268 14.9399 13.2268 14.6666C13.2268 12.3666 10.8801 10.4999 8.0001 10.4999C5.1201 10.4999 2.77344 12.3666 2.77344 14.6666C2.77344 14.9399 2.54677 15.1666 2.27344 15.1666C2.0001 15.1666 1.77344 14.9399 1.77344 14.6666C1.77344 11.8199 4.56677 9.49992 8.0001 9.49992C11.4334 9.49992 14.2268 11.8199 14.2268 14.6666C14.2268 14.9399 14.0001 15.1666 13.7268 15.1666Z",
    fill: "#00346B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlue);
export default __webpack_public_path__ + "static/media/PersonBlue.848e9cddc7851dc2ae01c94ff0b86665.svg";
export { ForwardRef as ReactComponent };